import { restApiMP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiMP.get("/api/mp-review", { params });
};

const getAllForCSV = params => {
  return restApiMP.get("/api/mp-review/csv", { params });
};

const mpReviewService = {
  getAll,
  getAllForCSV
};

export default mpReviewService;